import { useEffect } from 'react';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

const useCardSelectorItemClickDtm = (parentClass, dtm, categoriesOfCards) => {
  // US5148231: making a hook out of this so that multiple places can share.
  useEffect(
    () => {
      const handlerList = [];
      const eleSelector = `.${parentClass} button[class*="_cardContainer_"]`;
      const cardList = categoriesOfCards.reduce((accumulator, category) => {
        if (Array.isArray(category.cards)) {
          category.cards.forEach(card => {
            accumulator.push(card);
          });
        }
        return accumulator;
      }, []);
      const eleList = document.querySelectorAll(eleSelector);

      const createHandler = (cardObj, cta) => {
        return () => {
          const dtmObj = {
            ...dtm,
            eventAsset: replaceStringWithVars({
              varsObject: {
                productName: cardObj.dtmProductName,
                toggleType:
                  (cta.className || '').indexOf('_selected_') > -1
                    ? 'deselect'
                    : 'select'
              },
              string: dtm.eventAsset
            })
          };
          sendDTMClickEvent(dtmObj);
        };
      };

      if (eleList?.length > 0) {
        eleList.forEach((ele, index) => {
          const cardObj = cardList[index] || {};
          const handler = createHandler(cardObj, ele);
          handlerList.push(handler);
          ele.addEventListener('click', handler);
        });
      }

      return () => {
        if (eleList?.length > 0) {
          eleList.forEach((ele, index) => {
            ele.removeEventListener('click', handlerList[index]);
          });
        }
      };
    },
    [categoriesOfCards, parentClass, dtm]
  );
};

export default useCardSelectorItemClickDtm;
